import { render, staticRenderFns } from "./UiMarketProducer.vue?vue&type=template&id=4d23aaca&"
import script from "./UiMarketProducer.vue?vue&type=script&lang=js&"
export * from "./UiMarketProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports